import {Modal} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import {useNavigate} from "react-router-dom";
import MDButton from "../../components/MDButton";
import {InputAdornment} from "@mui/material";
import MDInput from "../../components/MDInput";
import {addToCart} from "../common/api/PortalCustomerApi";
import {Add, Remove} from "@mui/icons-material";
import InventoryModalBody from "../modal/InventoryModalBody";
import {validateGiftCardToken} from "../common/api/CartApi";

export default function ViewInventoryModal(props) {

  const navigate = useNavigate();
  const [context, setContext] = useContext(AppContext);
  const [client, setClient] = useState(props?.client);

  const [inventory, setInventory] = useState(props.inventory);
  const [addingToCart, setAddingToCart] = useState(false);
  const [maxQuantity, setMaxQuantity] = useState(props?.inventory?.unlimited ? 999 : props?.inventory?.quantity);
  const [membershipType, setMembershipType] = useState(props?.membershipType);

  const [inventoryType, setInventoryType] = useState(props.inventoryType);
  const [formInvalid, setFormInvalid] = useState(false);

  const [isNew, setIsNew] = useState(!!!props.inventoryType?.guid);
  const [quantity, setQuantity] = useState(1);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setQuantity(1);
    setSaving(false);
  }, [props]);

  useEffect(() => {
    setInventory(props?.inventory);
    if (props?.inventory?.giftCard) {
      setGiftCardAmount(props?.inventory?.minAmount);
    }
  }, [props?.inventory]);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(inventoryType)
  });

  const loadCartFn = () => {
    let _context = {...context};
    _context.reloadCart = true;
    setContext({..._context});
  };

  const handleClose = () => {
    props.handleClose();
  };

  const [tokenError, setTokenError] = useState(null);

  const verifyGiftCard = (giftCard) => {
    setTokenError(null);
    validateGiftCardToken(giftCard).then((resp)=> {
      props.handleSave(giftCard);
    }).catch((err)=> {
      setTokenError(err.message);
    });
  }

  const handleSave = () => {

    setSaving(true);

    let _e = {...inventory};
    let giftRecipient = {
      recipientName: giftCardRecipientName,
      email: giftCardRecipientEmail,
      message: giftCardRecipientMessage,
      sendDate: giftCardRecipientSendDate,
      deliverFuture: giftCardDeliverFuture,
      giftCardInternal: giftCardInternal,
      giftCardTokenKey: giftCardTokenKey,
      giftCardTokenValue: giftCardTokenValue,
      giftCardType: giftCardType
    }

    _e.giftRecipient = giftRecipient;
    _e.membershipMembers = membershipMembers;
    _e.quantity = quantity;
    _e.giftCardAmount = giftCardAmount;
    _e.cafeOptions = cafeOptions;

    if (giftCardTokenValue?.length > 0) {
      verifyGiftCard(_e);
      return;
    }

    props.handleSave(_e);
  };

  const [giftCardAmount, setGiftCardAmount] = useState(0);
  const [giftCardRecipientName, setGiftCardRecipientName] = useState();
  const [giftCardRecipientEmail, setGiftCardRecipientEmail] = useState();
  const [giftCardRecipientMessage, setGiftCardRecipientMessage] = useState();
  const [giftCardRecipientSendDate, setGiftCardRecipientSendDate] = useState();
  const [giftCardTokenKey, setGiftCardTokenKey] = useState();
  const [giftCardTokenValue, setGiftCardTokenValue] = useState();

  const [giftCardDeliverFuture, setGiftCardDeliverFuture] = useState(false);
  const [giftCardType, setGiftCardType] = useState();
  const [giftCardInternal, setGiftCardInternal] = useState(false);

  const [items, setItems] = useState('');
  const [cafeValid, setCafeValid] = useState(true);
  const [membershipValid, setMembershipValid] = useState(true);
  const [membershipMembers, setMembershipMembers] = useState([]);

  const [cafeOptions, setCafeOptions] = useState();
  const itemCallback = (condition) => {
    setItems(condition);
  }
  return (
    <>
      {inventory &&
        <Modal onHide={handleClose} size={'lg'} show={props.show}>
          <form onSubmit={handleSubmit(handleSave)} id={'registerEventForm'}>
            <Modal.Header closeButton>
              <Modal.Title>{inventory.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

              <InventoryModalBody
                key={inventory.guid}
                itemCallback={itemCallback}
                inventory={inventory}
                quantity={quantity}
                client={client}
                giftCardError={tokenError}
                giftCardRecipientCallback={(e) => {
                  if (e?.giftCardType != null) {
                    setGiftCardType(e.giftCardType);
                  } else if (e.target.name === 'giftCardRecipientName') {
                    setGiftCardRecipientName(e.target.value)
                  } else if (e.target.name === 'giftCardRecipientEmail') {
                    setGiftCardRecipientEmail(e.target.value)
                  } else if (e.target.name === 'giftCardRecipientMessage') {
                    setGiftCardRecipientMessage(e.target.value)
                  } else if (e.target.name === 'giftCardTokenKey') {
                    setGiftCardTokenKey(e.target.value)
                  } else if (e.target.name === 'giftCardTokenValue') {
                    setGiftCardTokenValue(e.target.value)
                  } else if (e.target.name === 'giftCardAmount') {
                    setGiftCardAmount(parseFloat(e.target.value).toFixed(2));
                  } else if (e.target.name === 'giftCardRecipientSendDate') {
                    setGiftCardRecipientSendDate(new Date(e.target.value))
                  } else if (e.target.name === 'giftCardDeliverFuture') {
                    setGiftCardDeliverFuture(e.target.checked ? true : false)
                  } else if (e.target.name === 'giftCardInternal') {
                    setGiftCardInternal(e.target.checked ? true : false)
                  }
                }}
                membershipCallback={(cb) => {
                  setMembershipValid(cb?.membershipValid);
                  setMembershipMembers(cb?.membershipMembers);
                }}
                cafeCallback={(cb) => {
                  setCafeValid(cb?.orderValid);
                  setCafeOptions(cb?.cafeOptions);
                }}/>

            </Modal.Body>
            <Modal.Footer>

              {!membershipType && !inventory?.giftCard && maxQuantity > 1 &&
                <MDInput type="text" step="1" required
                         onChange={(e) => {
                           setQuantity(e.target.value);
                         }}
                         InputProps={{
                           readOnly: true,
                           startAdornment: <InputAdornment position="start"
                                                           className={'cursor-pointer'}
                                                           onClick={(e) => {
                                                             let _q = quantity - 1;
                                                             if (_q > 0) {
                                                               setQuantity(_q);
                                                             }
                                                           }}>
                             <Remove/>
                           </InputAdornment>,
                           endAdornment: <InputAdornment position="end"
                                                         className={'cursor-pointer'}
                                                         onClick={(e) => {
                                                           let _q = quantity;
                                                           if (_q + 1 <= maxQuantity) {
                                                             setQuantity(_q + 1);
                                                           }
                                                         }}>
                             <Add/>
                           </InputAdornment>,
                         }}
                         value={quantity || 1}
                         autoComplete="off"
                         className="form-control" id="quantity"
                         label="Quantity"
                         style={{width: '125px'}}/>
              }

              {giftCardInternal &&
                <MDButton
                  type="submit"
                  variant="gradient"
                  color="info"
                  style={{marginLeft: '10px'}}
                  disabled={saving || formInvalid}>
                  {saving ? 'Saving...' : <>Save Gift Card</>}
                </MDButton>
              }
              {!giftCardInternal && <MDButton
                type="submit"
                variant="gradient"
                color="info"
                style={{marginLeft: '10px'}}
                disabled={addingToCart || formInvalid || !cafeValid || !membershipValid}>
                {addingToCart ? 'Adding to Cart...' : <>Add&nbsp;{items && items}to Cart</>}
              </MDButton>
              }

            </Modal.Footer>
          </form>
        </Modal>
      }
    </>
  );
}